import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { Search, Users, Code2, CheckCircle } from 'lucide-react';
const steps = [{
  icon: Search,
  title: 'Analyse',
  desc: 'Reale Abläufe vor Ort verstehen'
}, {
  icon: Users,
  title: 'Zusammenarbeit',
  desc: 'Enge Arbeit mit Fachabteilungen'
}, {
  icon: Code2,
  title: 'Entwicklung',
  desc: 'Iterativ, transparent & agil'
}, {
  icon: CheckCircle,
  title: 'Ergebnis',
  desc: 'Verständliche Lösungen ohne Ballast'
}];
export function ProcessSlide() {
  return <SlideWrapper data-id="element-169">
      <div className="h-full flex flex-col justify-center" data-id="element-170">
        <motion.h2 className="text-5xl font-bold text-primary mb-16" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} data-id="element-171">
          Wie wir arbeiten
        </motion.h2>

        <div className="relative" data-id="element-172">
          {/* Connecting Line */}
          <div className="absolute top-10 left-0 w-full h-1 bg-gray-100 -z-10 hidden md:block" data-id="element-173">
            <motion.div className="h-full bg-accent" initial={{
            width: 0
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 3,
            delay: 0.5,
            ease: 'easeInOut'
          }} data-id="element-174" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-175">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + index * 0.4
          }} className="flex flex-col items-center text-center bg-white md:bg-transparent p-6 md:p-0 rounded-xl shadow-sm md:shadow-none border md:border-0 border-gray-100" data-id="element-176">
                <div className="w-20 h-20 bg-white border-4 border-accent rounded-full flex items-center justify-center mb-6 shadow-sm z-10" data-id="element-177">
                  <step.icon className="w-8 h-8 text-primary" data-id="element-178" />
                </div>
                <h3 className="text-xl font-bold text-primary mb-2" data-id="element-179">
                  {step.title}
                </h3>
                <p className="text-text-secondary" data-id="element-180">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </SlideWrapper>;
}